import React, { useState,useMemo } from 'react';
import ReportIssue from './reportIssue';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux';
import { getReviewTopicDetails,
        reviewTopicDetailsSuccess, 
        recalculateTopicSentiments, 
        reviewsSelector, 
        triggerRegenerateRelevanceFacts,
         fetchSimilarReviews, 
         executeAgent,
         RegeneratePHI,
         RegenerateEmployeeName,
         RegenerateInappropriateInstructions} from '../../../../../store/slices/reviews';
import SectionTemplate from '../../../../../common/sectionTemplate';
import RelevanceFacts from './relevanceFacts';
import { locationsSelector } from '../../../../../store/slices/location';
import ReviewIcons from './reviewIcon';
import ReviewAgentDetails from './reviewAgentDetails';
import ReviewActonLog from '../factModals/reviewActionLog';
import { uTCtoLocalforTime } from '../../../../../common/utils';
import TopicSentiments from './topicSentiments';
import { Box, Collapse, Dialog, DialogContent, 
         DialogTitle, IconButton, Link, Stack, 
         Tooltip, Typography } from '@mui/material'
import PHI from './Phi';
import EmployeeName from './EmployeeName';
import InappropriateInstructions from './InappropriateInstructions';

const MoreDetails = ({ open = false, review = '', handleClose, size = 'md',selectedCompany }) => {
    const [isCollapsed, setIsCollapsed] = useState({ agent: true, sentiment: true, review: true, facts: true,PHI:true,EmployeeName:true,InappropriateInstructions:true});
    const dispatch = useDispatch()
    const { reviewTopicDetails,similarReviews,LogsData} = useSelector(reviewsSelector)
    const [openCollpase, setOpenCollapse] = useState(false)
    const [isopen, setIsOpen] = useState(false);
    const [isopenRevLog,setIsOpenRevLog] = useState(false)
    const [isopenPhiLog,setIsOpenPhiLog] = useState(false)
    const [isopenRelevantNames,setIsOpenRelevantNames] = useState(false)
    const [isopenEmployeeNameLog,setIsOpenEmployeeNameLog] =  useState(false)
    const [isopenInappropriateInstructionsLog,setIsOpenInappropriateInstructionsLog] = useState(false)
    const {facts}=useSelector(locationsSelector)

   
       const handleCollapseChange = (val, key) => {
        setIsCollapsed(prev => ({ ...prev, [key]: val }));
        };

      const onClose = () => {
        dispatch(reviewTopicDetailsSuccess([]))
        handleClose()
        }

       useEffect(() => {
         if (review?.reviewId) {
            dispatch(getReviewTopicDetails(review?.reviewId))
            dispatch(fetchSimilarReviews(review?.reviewId))
            }
         }, [review?.reviewId])

  

       const reviewRelevantFacts=useMemo(()=>{
       const tempData=similarReviews?.agents?.relevanceFacts
       return tempData
       },[similarReviews])

       const reviewRelevantName=useMemo(()=>{
       const tempData=similarReviews?.agents?.reviewerName
       return tempData
      },[similarReviews])


        const reviewRelevantNames = useMemo(() => {
        const tempData = similarReviews?.agents?.reviewerName;
        if (tempData && typeof tempData === 'string') {
           const parsedData = JSON.parse(tempData);   
            if (parsedData && parsedData.ReviewerName && parsedData.RequestId && parsedData.RunOn) {
            const { RequestId, ReviewerName,RunOn } = parsedData;
            return { RequestId, ReviewerName,RunOn };
            }
          }
            return null;
          }, [similarReviews]);

         

          const reviewRelevantPhi = useMemo(() => {
            const tempData = similarReviews?.agents?.phi;
            if (tempData && typeof tempData === 'string') {
              const parsedData = JSON.parse(tempData);   
              const { RequestId, PHI, RunOn } = parsedData;        
              return {
                RequestId,
                PHI, 
                RunOn
              };
            }         
            return null;
          }, [similarReviews]);
          


              const dilalogPhiHandlerIsOpen = () => {
                if (!isopenPhiLog && parsedData?.reqId) { 
                  setIsOpenPhiLog(true)
                }  
               }
      
            
               const closePhiHandler = () => {
                setIsOpenPhiLog(false)
               }


               const reviewRelevantEmployeeName = useMemo(() => {
                const tempData = similarReviews?.agents?.employeeName;
                if (tempData && typeof tempData === 'string') {
                  const parsedData = JSON.parse(tempData);   
                  const { RequestId, EmployeeName, RunOn } = parsedData;        
                  return {
                    RequestId,
                    EmployeeName, 
                    RunOn
                  };
                }         
                return null;
              }, [similarReviews]);

    
    
                  const dilalogEmployeeNameHandlerIsOpen = () => {
                    if (!isopenEmployeeNameLog && parsedData?.reqId) { 
                      setIsOpenEmployeeNameLog(true)
                    }  
                   }
          
                
                   const closeEmployeeNameHandler = () => {
                    setIsOpenEmployeeNameLog(false)
                   }
                  
                   const reviewRelevantInappropriateInstructions = useMemo(() => {
                    const tempData = similarReviews?.agents?.inappropriateInstructions;                
                    if (tempData && typeof tempData === 'string') {                  
                        const parsedData = JSON.parse(tempData);
                        const { RequestId, RunOn } = parsedData;
                        const instructions = parsedData?.InappropriateInstructions?.InappropriateInstructions;               
                        return {
                          RequestId,
                          RunOn,
                          InappropriateInstructions: instructions || [],
                        };                  
                    }
                  
                    return null;
                  }, [similarReviews]);
                  

                   const dilalogInappropriateInstructionsHandlerIsOpen = () => {
                    if (!isopenInappropriateInstructionsLog && parsedData?.reqId) { 
                      setIsOpenInappropriateInstructionsLog(true)
                    }  
                   }
          
                
                   const closeInappropriateInstructionsHandler = () => {
                    setIsOpenInappropriateInstructionsLog(false)
                   }


                   const getInappropriateInstructions = () => {
                    dispatch(RegenerateInappropriateInstructions(review?.reviewId));
                  };
            
      


          const sentimentsData = useMemo(() => {
          const tempData = similarReviews?.agents?.sentiments;
          if (tempData && typeof tempData === 'string') {
              const parsedData = JSON.parse(tempData);       
              if (parsedData &&  parsedData.RequestId && parsedData.RunOn) {
              const { RequestId,RunOn } = parsedData;
              return { RequestId, RunOn };
              }
            }           
              return null;
          }, [similarReviews]);


  
           const parsedData = useMemo(() => {
            try { 
              const data = JSON.parse(reviewRelevantFacts);
              const { RelevanceFacts, RunOn, RequestId: reqId } = data;
              return { RelevanceFacts, RunOn, reqId };
            } catch (error) {         
              return {}; 
            }
          }, [reviewRelevantFacts]); 


          const memoizedLogsData = useMemo(() => {
            if (LogsData && Array.isArray(LogsData)) {
              return LogsData.map(log => ({
                ...log,
                callEndTime: uTCtoLocalforTime(log.callEndTime), 
              }));
            }
            return [];
           }, [LogsData]);
        

          const saveHandler = () => {
            if (!isopenRelevantNames && reviewRelevantNames?.RequestId) {
              setIsOpenRelevantNames(true);
            }
          };
  

          const handleSave = () => {
           if (!isopen && sentimentsData?.RequestId) {
            setIsOpen(true);
           }
          };
  
         const dilalogHandlerIsOpen = () => {
         if (!isopenRevLog && parsedData?.reqId) { 
         setIsOpenRevLog(true)
         }  
        }


       
        const closeHandler = () => {
          setIsOpenRevLog(false)
         }

        const handleCloses = () => {
        setIsOpen(false);
        };

       const handleClosesRelevantNames = () => {
       setIsOpenRelevantNames(false);
       }


       const onRecalculateTopicSentiment = reviewId => {
        dispatch(recalculateTopicSentiments(reviewId));
        };

         const onRegenerateRelevanceFacts=()=>{
         dispatch(triggerRegenerateRelevanceFacts(review?.reviewId))
         }

    
        const onRegenerateRelevanceNames = () => {
        dispatch(executeAgent(review?.reviewId))
        }


        const handleRun=()=>{
          dispatch(RegeneratePHI(review?.reviewId))
      
      }


      const getEmployeeName = () => {
        dispatch(RegenerateEmployeeName(review?.reviewId))
      }


    return (
      <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      unmountonexit={"true"}
      sx={{ marginTop: "50px" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Stack direction={"row"} alignItems={"center"}>
            {"Review"}&nbsp;
            <Typography variant="body1">({review?.reviewId})</Typography>
          </Stack>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ minHeight: "50vh", pb: 2 }}>
          <Stack spacing={2} pt={2}>
            {reviewRelevantNames && (
              <SectionTemplate
                header="Determined First Name"
                collapseState={isCollapsed.agent}
                onCollapseChange={(val) => handleCollapseChange(val, "agent")}
                noSwitch={true}
              >
                <ReviewAgentDetails data={reviewRelevantNames} />

                <Stack
                  justifyContent={
                    reviewRelevantName ? "space-between" : "right"
                  }
                  direction={"row"}
                >
                  {reviewRelevantNames?.RequestId && (
                    <Typography
                      variant="caption"
                      className="text-muted"
                      fontStyle={"italic"}
                      sx={{ whiteSpace: "nowrap", paddingRight: "5px" }}
                    >
                      Last run on{" "}
                      {uTCtoLocalforTime(reviewRelevantNames?.RunOn)}
                    </Typography>
                  )}
                  {reviewRelevantNames?.RequestId && (
                    <Link
                      onClick={saveHandler}
                      style={{
                        textDecoration: "none",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Tooltip
                        arrow
                        title={"Log"}
                        disableInteractive
                        enterDelay={500}
                        leaveDelay={200}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            mt: 0,
                            mr: 96,
                          }}
                        >
                          <ReviewIcons
                            iconType="moreDetails"
                            sx={{
                              width: "60px",
                              height: "60px",
                              marginLeft: 8,
                            }}
                          />
                        </Box>
                      </Tooltip>
                    </Link>
                  )}

                  {isopenRelevantNames && (
                    <ReviewActonLog
                      key={reviewRelevantNames?.RequestId}
                      open={isopenRelevantNames}
                      handleClose={handleClosesRelevantNames}
                      memoizedLogsData={memoizedLogsData}
                      reviewId={review?.reviewId}
                      companyId={selectedCompany}
                      RequestId={reviewRelevantNames?.RequestId}
                      title={"Determined First Name Log"}
                    />
                  )}

                  <Link
                    onClick={(e) => {
                      onRegenerateRelevanceNames();
                      e.stopPropagation();
                    }}
                    sx={{ cursor: 'pointer' }} 
                  >
                    {!reviewRelevantName ? "Reassess" : "Reassess"}
                  </Link>
                </Stack>
              </SectionTemplate>
            )}

            {reviewRelevantFacts && (
              <SectionTemplate
                header="Relevant Facts"
                collapseState={isCollapsed.facts}
                onCollapseChange={(val) => handleCollapseChange(val, "facts")}
                noSwitch={true}
              >
                <RelevanceFacts data={reviewRelevantFacts} />
                <Stack
                  justifyContent={
                    reviewRelevantFacts ? "space-between" : "right"
                  }
                  direction={"row"}
                >
                  {reviewRelevantFacts && (
                    <Stack direction={"row"}>
                      <Typography
                        variant="caption"
                        className="text-muted"
                        fontStyle={"italic"}
                        sx={{ whiteSpace: "nowrap", paddingRight: "5px" }}
                      >
                        Last run on {uTCtoLocalforTime(parsedData.RunOn)}
                      </Typography>
                    </Stack>
                  )}
                  {parsedData?.reqId && (
                    <Link
                      onClick={dilalogHandlerIsOpen}
                      style={{
                        textDecoration: "none",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Tooltip
                        arrow
                        title={"Log"}
                        disableInteractive
                        enterDelay={500}
                        leaveDelay={200}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            mt: 0,
                            mr: 96,
                          }}
                        >
                          <ReviewIcons
                            iconType="moreDetails"
                            sx={{
                              width: "60px",
                              height: "60px",
                            }}
                          />
                        </Box>
                      </Tooltip>
                    </Link>
                  )}

                  {isopenRevLog && (
                    <ReviewActonLog
                      key={parsedData?.reqId}
                      open={isopenRevLog}
                      handleClose={closeHandler}
                      memoizedLogsData={memoizedLogsData}
                      reviewId={review?.reviewId}
                      companyId={selectedCompany}
                      RequestId={parsedData?.reqId}
                      title={"Relevant Facts Log"}
                    />
                  )}
                  <Link
                   sx={{ display: "flex", pb: 1, cursor: "pointer" }}
                    onClick={(e) => {
                      onRegenerateRelevanceFacts();
                      e.stopPropagation();
                    }}
                  >
                    {!reviewRelevantFacts ? "Reassess" : "Reassess"}
                  </Link>
                </Stack>
              </SectionTemplate>
            )}

            <SectionTemplate
              header="Sentiments"
              collapseState={isCollapsed.sentiment}
              onCollapseChange={(val) => handleCollapseChange(val, "sentiment")}
              noSwitch={true}
            >
               <TopicSentiments />

              <Stack
                justifyContent={sentimentsData ? "space-between" : "right"}
                direction={"row"}
              >
                {sentimentsData?.RequestId && (
                  <Typography
                    variant="caption"
                    className="text-muted"
                    fontStyle={"italic"}
                    sx={{ whiteSpace: "nowrap", paddingRight: "5px" }}
                  >
                    Last run on {uTCtoLocalforTime(sentimentsData?.RunOn)}
                  </Typography>
                )}

                {sentimentsData?.RequestId && (
                  <Link
                    onClick={handleSave}
                    style={{
                      textDecoration: "none",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Tooltip
                      arrow
                      title={"Log"}
                      disableInteractive
                      enterDelay={500}
                      leaveDelay={200}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          mt: 0,
                          mr: 96,
                        }}
                      >
                        <ReviewIcons
                          iconType="moreDetails"
                          sx={{
                            width: "60px",
                            height: "60px",
                          }}
                        />
                      </Box>
                    </Tooltip>
                  </Link>
                )}

                 {isopen && (
                  <ReviewActonLog
                    key={sentimentsData?.RequestId}
                    open={isopen}
                    memoizedLogsData={memoizedLogsData}
                    handleClose={handleCloses}
                    RequestId={sentimentsData?.RequestId}
                    reviewId={review?.reviewId}
                    companyId={selectedCompany}
                    title={"sentiments"}
                  />
                )}
                <Link
                  sx={{ display: "flex", pb: 1, cursor: "pointer" }}
                  onClick={(e) => {
                    onRecalculateTopicSentiment(review?.reviewId);
                    e.stopPropagation();
                  }}
                >
                  {"Reassess"}
                </Link>
              </Stack>
              <Stack justifyContent={"right"} direction={"row"} >
                      <Link
                        component={"button"}
                        // disabled
                        sx={{
                          width: "fit-content",
                          mt:-1
                        }}
                        aria-disabled="disabled"
                        onClick={() => setOpenCollapse((prev) => !prev)}
                      >
                        Report an issue
                      </Link>
                    </Stack>
            </SectionTemplate>

            <SectionTemplate
              header="PHI"
              collapseState={isCollapsed.PHI}
              onCollapseChange={(val) => handleCollapseChange(val, "PHI")}
              noSwitch={true}
              >
              <PHI/>
              <Stack
                justifyContent={reviewRelevantPhi ? "space-between" : "right"}
                direction={"row"}
              >
                {reviewRelevantPhi?.RequestId && (
                  <Typography
                    variant="caption"
                    className="text-muted"
                    fontStyle={"italic"}
                    sx={{ whiteSpace: "nowrap", paddingRight: "5px" }}
                  >
                    Last run on {uTCtoLocalforTime(reviewRelevantPhi?.RunOn)}
                  </Typography>
                )}

                {reviewRelevantPhi?.RequestId && (
                  <Link
                    onClick={dilalogPhiHandlerIsOpen}
                    style={{
                      textDecoration: "none",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Tooltip
                      arrow
                      title={"Log"}
                      disableInteractive
                      enterDelay={500}
                      leaveDelay={200}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          mt: 0,
                          mr: 96,
                        }}
                      >
                        <ReviewIcons
                          iconType="moreDetails"
                          sx={{
                            width: "60px",
                            height: "60px",
                          }}
                        />
                      </Box>
                    </Tooltip>
                  </Link>
                )}

                {isopenPhiLog && (
                  <ReviewActonLog
                    key={reviewRelevantPhi?.RequestId}
                    open={isopenPhiLog}
                    memoizedLogsData={memoizedLogsData}
                    handleClose={closePhiHandler}
                    RequestId={reviewRelevantPhi?.RequestId}
                    reviewId={review?.reviewId}
                    companyId={selectedCompany}
                    title={"Phi"}
                  />
                )}
                <Link
                  sx={{ display: "flex", pb: 1, cursor: "pointer" }}
                  onClick={(e) => {
                    handleRun(review?.reviewId);
                    e.stopPropagation();
                  }}
                >
                  {"Reassess"}
                </Link>
              </Stack>
            </SectionTemplate>

            <SectionTemplate
              header="Employee Name"
              collapseState={isCollapsed.EmployeeName}
              onCollapseChange={(val) => handleCollapseChange(val, "EmployeeName")}
              noSwitch={true}
            >
              <EmployeeName/>

              <Stack
                justifyContent={reviewRelevantEmployeeName ? "space-between" : "right"}
                direction={"row"}
              >
                {reviewRelevantEmployeeName?.RequestId && (
                  <Typography
                    variant="caption"
                    className="text-muted"
                    fontStyle={"italic"}
                    sx={{ whiteSpace: "nowrap", paddingRight: "5px" }}
                  >
                    Last run on {uTCtoLocalforTime(reviewRelevantEmployeeName?.RunOn)}
                  </Typography>
                )}

                {reviewRelevantEmployeeName?.RequestId && (
                  <Link
                    onClick={dilalogEmployeeNameHandlerIsOpen}
                    style={{
                      textDecoration: "none",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Tooltip
                      arrow
                      title={"Log"}
                      disableInteractive
                      enterDelay={500}
                      leaveDelay={200}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          mt: 0,
                          mr: 96,
                        }}
                      >
                        <ReviewIcons
                          iconType="moreDetails"
                          sx={{
                            width: "60px",
                            height: "60px",
                          }}
                        />
                      </Box>
                    </Tooltip>
                  </Link>
                )}

                {isopenEmployeeNameLog && (
                  <ReviewActonLog
                    key={reviewRelevantEmployeeName?.RequestId}
                    open={isopenEmployeeNameLog}
                    memoizedLogsData={memoizedLogsData}
                    handleClose={closeEmployeeNameHandler}
                    RequestId={reviewRelevantEmployeeName?.RequestId}
                    reviewId={review?.reviewId}
                    companyId={selectedCompany}
                    title={"Employee Name"}
                  />
                )}
                <Link
                  sx={{ display: "flex", pb: 1, cursor: "pointer" }}
                  onClick={(e) => {
                    getEmployeeName(review?.reviewId);
                    e.stopPropagation();
                  }}
                >
                  {"Reassess"}
                </Link>
              </Stack>
            </SectionTemplate>
            <SectionTemplate
              header="Inappropriate Instructions"
              collapseState={isCollapsed.InappropriateInstructions}
              onCollapseChange={(val) => handleCollapseChange(val, "InappropriateInstructions")}
              noSwitch={true}
            >
             <InappropriateInstructions/>

              <Stack
                justifyContent={reviewRelevantInappropriateInstructions ? "space-between" : "right"}
                direction={"row"}
              >
                {reviewRelevantInappropriateInstructions?.RequestId && (
                  <Typography
                    variant="caption"
                    className="text-muted"
                    fontStyle={"italic"}
                    sx={{ whiteSpace: "nowrap", paddingRight: "5px" }}
                  >
                    Last run on {uTCtoLocalforTime(reviewRelevantInappropriateInstructions?.RunOn)}
                  </Typography>
                )}

                {reviewRelevantInappropriateInstructions?.RequestId && (
                  <Link
                    onClick={dilalogInappropriateInstructionsHandlerIsOpen}
                    style={{
                      textDecoration: "none",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Tooltip
                      arrow
                      title={"Log"}
                      disableInteractive
                      enterDelay={500}
                      leaveDelay={200}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          mt: 0,
                          mr: 96,
                        }}
                      >
                        <ReviewIcons
                          iconType="moreDetails"
                          sx={{
                            width: "60px",
                            height: "60px",
                          }}
                        />
                      </Box>
                    </Tooltip>
                  </Link>
                )}

                {isopenInappropriateInstructionsLog && (
                  <ReviewActonLog
                    key={reviewRelevantInappropriateInstructions?.RequestId}
                    open={isopenInappropriateInstructionsLog}
                    memoizedLogsData={memoizedLogsData}
                    handleClose={closeInappropriateInstructionsHandler}
                    RequestId={reviewRelevantInappropriateInstructions?.RequestId}
                    reviewId={review?.reviewId}
                    companyId={selectedCompany}
                    title={"Inappropriate Instructions"}
                  />
                )}
                <Link
                  sx={{ display: "flex", pb: 1, cursor: "pointer" }}
                  onClick={(e) => {
                    getInappropriateInstructions(review?.reviewId);
                    e.stopPropagation();
                  }}
                >
                  {"Reassess"}
                </Link>
              </Stack>
            </SectionTemplate>
           
            {openCollpase && (
              <div style={{ paddingTop: "16px" }}>
                <Collapse in={openCollpase}>
                  <ReportIssue
                    entityId={review?.reviewId}
                    entityType={"Review"}
                    issueType={"Topics"}
                    dataLabel={"Topics"}
                    data={_.join(_.split(review?.topicData, ","), ", ")}
                    isOpenIssues={true}
                  />
                </Collapse>
              </div>
            )}
          </Stack>
        </DialogContent>
      </Dialog>
    );
}

export default MoreDetails
